import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function duplicateValidator(
  compareArray: any[],
  compareProperty: string,
  originalValue?: any
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const inputValue = control.value ? String(control.value).trim() : '';

    if (!inputValue || (!!originalValue && String(originalValue) === inputValue)) {
      return null;
    }

    const isDuplicate = compareArray.some(
      (data) => inputValue === String(data[compareProperty]).trim()
    );

    return isDuplicate ? { duplicateValue: true } : null;
  };
}

export function intervalTimeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const number = Number(control.value);

    if (Number.isNaN(number) || number % 1 !== 0 || number < 1) {
      return { intervalTime: true };
    }

    return null;
  };
}
